import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdaptCommonProgressModule } from "@common/progress/common-progress.module";
import { AdaptToolbarModule } from "@common/shell/toolbar/toolbar.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptDashboardElementModule } from "@common/ux/dashboard-element/dashboard-element.module";
import { AdaptProgressBarModule } from "@common/ux/progress-bar/progress-bar.module";
import { AdaptStyledDashboardElementModule } from "@common/ux/styled-dashboard-element/styled-dashboard-element.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AdaptUniversalDashboardElementModule } from "@common/ux/universal-dashboard-element/universal-dashboard-element.module";
import { AuthorisationService } from "@org-common/lib/authorisation/authorisation.service";
import { DxPieChartModule, DxSortableModule } from "devextreme-angular";
import { JourneyProgressAuthService } from "./journey-progress-auth.service";
import { JourneyProgressDashboardElementComponent } from "./journey-progress-dashboard-element/journey-progress-dashboard-element.component";
import { JourneyProgressPageComponent, journeyProgressPageRoute } from "./journey-progress-page/journey-progress-page.component";


@NgModule({
    declarations: [
        JourneyProgressPageComponent,
        JourneyProgressDashboardElementComponent,
    ],
    imports: [
        CommonModule,
        AdaptButtonModule,
        AdaptToolbarModule,
        AdaptCommonProgressModule,
        AdaptStyledDashboardElementModule,
        DxPieChartModule,
        DxSortableModule,
        AdaptDashboardElementModule,
        AdaptUniversalDashboardElementModule,
        AdaptProgressBarModule,
        AdaptTooltipModule,
    ],
    exports: [
        JourneyProgressDashboardElementComponent,
    ],
})
export class AdaptJourneyProgressModule {
    public static readonly Routes = [
        ...journeyProgressPageRoute.routes,
    ];

    constructor(authorisationService: AuthorisationService) {
        JourneyProgressAuthService.registerAccess(authorisationService);
    }
}
